export type PortalConfigURLs = {
  portal: string;
  admin: string;
  timetracker: string;
  directory: string;
  pto: string;
  calendar: string;
  onekg: string;
  handbook: string;
  powerhours: string;
  vault: string;
  vaultPublic: string;
  appshop: string;
  playbook: string;
  myteam: string;
  pulse: string;
  polaris: string;
  onboarding: string;
  backendUrl: string;
  graphqlUrl: string;
  loginUrl: string;
  logoutUrl: string;
  it: string;
  brainstationOnline: string;
  licenseTracker: string;
  chatKgpt: string;
  development?: PortalConfigURLs;
  staging?: PortalConfigURLs;
  production?: PortalConfigURLs;
  assetControl: string;
};

export type PortalConfigType = {
  dayjs: {
    thresholds: Array<{ l: string; r?: number; d?: string }>;
  };
  assetUrl: string;
  notifications: {
    applicationServerKey: string;
    deviceTokenVersion: string;
  };
  urls: PortalConfigURLs;
};

const config: PortalConfigType = {
  dayjs: {
    thresholds: [
      { l: 's', r: 44, d: 'second' },
      { l: 'm', r: 89, d: 'second' },
      { l: 'mm', r: 44, d: 'minute' },
      { l: 'h', r: 89, d: 'minute' },
      { l: 'hh', r: 21, d: 'hour' },
      { l: 'd', r: 47, d: 'hour' },
      { l: 'dd', r: 30, d: 'day' },
      { l: 'M', r: 60, d: 'day' },
      { l: 'MM', r: 11, d: 'month' },
      { l: 'y', r: 1 },
      { l: 'yy', d: 'year' },
    ],
  },
  assetUrl: 'https://portal-assets-prod.s3.amazonaws.com/uilib/',
  notifications: {
    applicationServerKey: 'BP7eZVCF69jF9azCOSi7gwIqW45_W6faypZgiS0FXnJRJki1b829Y64h4cLX4ZQz234glsWwwu0hFP2N7ZsZZJA',
    deviceTokenVersion: 'v1',
  },
  urls: {
    portal: 'https://kgportal.com',
    timetracker: 'https://projecttracker.kgportal.com',
    directory: 'https://directory.kgportal.com',
    pto: 'https://pto.kgportal.com',
    calendar: 'https://calendar.kgportal.com',
    onekg: 'https://handbook.kgportal.com/1kg',
    handbook: 'https://handbook.kgportal.com',
    powerhours: 'https://powerhours.kgportal.com',
    vault: 'https://vault.kgportal.com',
    vaultPublic: 'https://upload.kgportal.com',
    appshop: 'https://apps.kgportal.com',
    playbook: 'https://playbook.kgportal.com',
    myteam: 'https://myteam.kgportal.com',
    pulse: 'https://pulse.kgportal.com',
    polaris: 'https://polaris.konrad.com',
    onboarding: 'https://onboarding.kgportal.com',
    backendUrl: '',
    graphqlUrl: '/query',
    loginUrl: window.location.hostname.includes('konrad.com') ? 'https://auth.konrad.com' : 'https://auth.kgportal.com',
    logoutUrl: window.location.hostname.includes('konrad.com')
      ? 'https://auth.konrad.com/logout'
      : 'https://auth.kgportal.com/logout',
    it: 'https://konradgroup.atlassian.net/servicedesk/customer/portals',
    brainstationOnline: 'https://online.brainstation.io/login?email=',
    licenseTracker: 'https://licensetracker.kgportal.com',
    chatKgpt: 'https://chat.kgportal.com',
    admin: 'https://admin.kgportal.com',
    assetControl: 'https://assetcontrol.kgportal.com/',
    staging: {
      portal: 'https://stage.kgportal.com',
      timetracker: 'https://projecttracker.stage.kgportal.com',
      directory: 'https://directory.stage.kgportal.com',
      pto: 'https://pto.stage.kgportal.com',
      calendar: 'https://calendar.stage.kgportal.com',
      onekg: 'https://handbook.stage.kgportal.com/1kg',
      handbook: 'https://handbook.stage.kgportal.com',
      powerhours: 'https://powerhours.stage.kgportal.com',
      vault: 'https://vault.stage.kgportal.com',
      vaultPublic: 'https://upload.stage.kgportal.com',
      appshop: 'https://apps.stage.kgportal.com',
      playbook: 'https://playbook.stage.kgportal.com',
      myteam: 'https://myteam.stage.kgportal.com',
      pulse: 'https://pulse.stage.kgportal.com',
      polaris: 'https://polaris.stage.konrad.com',
      onboarding: 'https://onboarding.stage.kgportal.com',
      backendUrl: '',
      graphqlUrl: '/query',
      loginUrl: window.location.hostname.includes('konrad.com')
        ? 'https://auth.stage.konrad.com'
        : 'https://auth.stage.kgportal.com',
      logoutUrl: window.location.hostname.includes('konrad.com')
        ? 'https://auth.stage.konrad.com/logout'
        : 'https://auth.stage.kgportal.com/logout',
      it: 'https://konradgroup.atlassian.net/servicedesk/customer/portals',
      brainstationOnline: 'https://online.brainstation.io/login?email=',
      licenseTracker: 'https://bloodhound.stage.kgportal.com',
      chatKgpt: 'https://chat.stage.kgportal.com',
      admin: 'https://admin.stage.kgportal.com',
      assetControl: 'https://assetcontrol.staging.kgportal.com/',
    },
    development: {
      portal: 'https://dev.kgportal.com',
      timetracker: 'https://timetracker.dev.kgportal.com',
      // timetracker: 'http://localhost:3012',
      directory: 'https://directory.dev.kgportal.com',
      pto: 'https://pto.dev.kgportal.com',
      calendar: 'https://calendar.dev.kgportal.com',
      onekg: 'https://handbook.dev.kgportal.com/1kg',
      handbook: 'https://handbook.dev.kgportal.com',
      powerhours: 'https://powerhours.dev.kgportal.com',
      vault: 'https://vault.dev.kgportal.com',
      vaultPublic: 'http://localhost:3037',
      appshop: 'https://apps.dev.kgportal.com',
      playbook: 'https://playbook.dev.kgportal.com',
      myteam: 'https://myteam.dev.kgportal.com',
      pulse: 'https://pulse.dev.kgportal.com',
      polaris: 'https://polaris.dev.kgportal.com',
      onboarding: 'https://onboarding.dev.kgportal.com',
      backendUrl: 'http://localhost:6170',
      graphqlUrl: 'http://localhost:6170/query',
      loginUrl: 'https://auth.stage.kgportal.com',
      logoutUrl: 'https://auth.stage.kgportal.com/logout',
      it: 'https://konradgroup.atlassian.net/servicedesk/customer/portals',
      brainstationOnline: 'https://online.brainstation.io/login?email=',
      licenseTracker: 'https://licensetracker.kgportal.com',
      chatKgpt: 'https://chat.dev.kgportal.com',
      admin: 'https://admin.dev.kgportal.com',
      assetControl: 'https://assetcontrol.dev.kgportal.com/',
    },
    production: {
      portal: 'https://kgportal.com',
      timetracker: 'https://projecttracker.kgportal.com',
      directory: 'https://directory.kgportal.com',
      pto: 'https://pto.kgportal.com',
      calendar: 'https://calendar.kgportal.com',
      onekg: 'https://handbook.kgportal.com/1kg',
      handbook: 'https://handbook.kgportal.com',
      powerhours: 'https://powerhours.kgportal.com',
      vault: 'https://vault.kgportal.com',
      vaultPublic: 'https://upload.kgportal.com',
      appshop: 'https://apps.kgportal.com',
      playbook: 'https://playbook.kgportal.com',
      myteam: 'https://myteam.kgportal.com',
      pulse: 'https://pulse.kgportal.com',
      polaris: 'https://polaris.konrad.com',
      onboarding: 'https://onboarding.kgportal.com',
      backendUrl: '',
      graphqlUrl: '/query',
      loginUrl: window.location.hostname.includes('konrad.com')
        ? 'https://auth.konrad.com'
        : 'https://auth.kgportal.com',
      logoutUrl: window.location.hostname.includes('konrad.com')
        ? 'https://auth.konrad.com/logout'
        : 'https://auth.kgportal.com/logout',
      it: 'https://konradgroup.atlassian.net/servicedesk/customer/portals',
      brainstationOnline: 'https://online.brainstation.io/login?email=',
      licenseTracker: 'https://licensetracker.kgportal.com',
      chatKgpt: 'https://chat.kgportal.com',
      admin: 'https://admin.kgportal.com',
      assetControl: 'https://assetcontrol.kgportal.com/',
    },
  },
};

export default Object.freeze(config);
